import React from 'react';
import { resolvePublicFileUrl } from '../../utils/imageUrls';

export type MediaFit = 'cover' | 'contain';

export type MediaImageProps = {
  src?: string | null;
  alt: string;
  className?: string;
  fit?: MediaFit;
  /** object-position value, e.g. "center", "50% 30%" */
  position?: string;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
  draggable?: boolean;
  onClick?: () => void;
};

/**
 * Canonical image renderer — consistent object-fit and lazy loading.
 * Use fit="cover" for cards/heroes/avatars; fit="contain" for receipts/documents.
 */
export const MediaImage: React.FC<MediaImageProps> = ({
  src,
  alt,
  className = '',
  fit = 'cover',
  position = 'center',
  loading = 'lazy',
  fetchPriority,
  draggable = false,
  onClick,
}) => {
  const resolved = src ? resolvePublicFileUrl(src) || src : '';
  if (!resolved) {
    return (
      <div
        className={`bg-[#141414] flex items-center justify-center ${className}`}
        aria-hidden
      />
    );
  }

  return (
    <img
      src={resolved}
      alt={alt}
      loading={loading}
      fetchPriority={fetchPriority}
      draggable={draggable}
      onClick={onClick}
      className={`${fit === 'cover' ? 'object-cover' : 'object-contain'} ${className}`}
      style={{ objectPosition: position }}
    />
  );
};

export default MediaImage;
